export const PATHWAYS_SELECTION = "Pathways Selection";
export const CLINICAL_INFORMATION = "Clinical Information";
export const STAGING_INFO = "Staging Info";
export const BIO_MARKER = "Bio Marker";
export const DOCUMENTS = "Documents";
export const TUMOR_INFO_DIAGNOSIS = "tumor_info_diagnosis";